import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import Unauthorized from '../pages/Unauthorized';
import UserList from '../pages/Users/UserList';
import UserForm from '../pages/Users/UserForm';
import UserProfile from '../pages/Profile/UserProfile';
import { OWNER_ABOVE } from '../constants/roles';
import RoleProtectedRoute from '../components/RoleProtectedRoute';
import type { AppRoute } from './types';

// `*` stays last: index.tsx puts this module after the others.
export const adminRoutes: AppRoute[] = [
    { path: 'login', element: <Login />, handle: { public: true } },
    { index: true, element: <Dashboard /> },
    {
        path: 'users',
        children: [
            { index: true, element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={UserList} /> },
            { path: 'create', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={UserForm} /> },
            { path: 'edit/:id', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={UserForm} /> },
        ],
    },
    { path: 'profile', element: <UserProfile /> },
    { path: 'unauthorized', element: <Unauthorized /> },
    { path: '*', element: <NotFound /> },
];
